<template>
  <footer>ⓒ Gabia Inc. All Rights Reserved.</footer>
</template>

<script>
export default {};
</script>

<style></style>
